'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mortice = require('mortice');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var mortice__default = /*#__PURE__*/_interopDefaultLegacy(mortice);

var lock;

function createLock() {
  var repoOwner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (lock) {
    return lock;
  }

  var mutex = mortice__default["default"]({
    singleProcess: repoOwner
  });
  lock = {
    readLock: function readLock(func) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var releaseLock,
            _len,
            args,
            _key,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return mutex.readLock();

              case 2:
                releaseLock = _context.sent;
                _context.prev = 3;

                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _context.next = 7;
                return func.apply(null, args);

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
                _context.prev = 8;
                releaseLock();
                return _context.finish(8);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3,, 8, 11]]);
      }));
    },
    writeLock: function writeLock(func) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var releaseLock,
            _len2,
            args,
            _key2,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return mutex.writeLock();

              case 2:
                releaseLock = _context2.sent;
                _context2.prev = 3;

                for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                _context2.next = 7;
                return func.apply(null, args);

              case 7:
                return _context2.abrupt("return", _context2.sent);

              case 8:
                _context2.prev = 8;
                releaseLock();
                return _context2.finish(8);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3,, 8, 11]]);
      }));
    }
  };
  return lock;
}

exports.createLock = createLock;